import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the users api
 */
export class UserService extends BaseService {
	
	static get properties() {		
		return {
			currentUser: {type: Object}
		};
	}
	
	constructor() {
		super();
		this.currentUser = null;
	}
	
	async getCurrentUser() {
		
		if (!this.currentUser) {
			this.currentUser = await this.makeGETRequest("/api/resource/users/currentuser");		
			
			var user = this.currentUser;
			//inject behavior
			var companyFull = await Service.getCompanyService().getCurrentCompany();
			user.hasPermission = function(permission){
				var valid = false;
				var permissions = user.permissionMap[companyFull.company.companyId];
				if (permissions) {
					permissions.forEach(function(companyPermission){
						if (companyPermission === permission) {
							valid = true;
						}
					});
				}
				return valid;
			};
			
			
		}
		return this.currentUser;
	}
	
	clearCurrentUser() {
		this.currentUser = null;		
	}
	
	async getUsers(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var users = await this.makeGETRequest('/api/resource/users' + params);		
		return users;
	}
	
	async getUserCompanies(userId) {		
		var data = await this.makeGETRequest('/api/resource/users/' + userId + '/companies');		
		return data;
	}
	
	async deleteUserFromCompany(userId, companyId) {		
		var result = await this.makeDELETERequest('/api/resource/users/' + userId + '/companies/' + companyId);		
		return result;
	}	
	
	async addUserToCompanies(userId, companyId, primary, managedAccountType) {
		var params = '?primary=' + primary;
		if (managedAccountType) {
			params += '&managedAccountType=' + encodeURIComponent(managedAccountType);
		}
		var result = await this.makePOSTRequest('/api/resource/users/' + userId + '/companies/' + companyId + params);		
		return result;
	}

	async updateUserCompany(userId, companyId, primary, managedAccountType) {
		var params = '?primary=' + primary;
		if (managedAccountType) {
			params += '&managedAccountType=' + encodeURIComponent(managedAccountType);
		} else {
			params += '&managedAccountType=';
		}
		var result = await this.makePUTRequest('/api/resource/users/' + userId + '/companies/' + companyId + params, {});		
		return result;
	}
	
	async updateProfile(data) {
		var result = await this.makePUTRequest('/api/resource/users/' + data.userId, data);
		this.currentUser = null;
		return result;
	}
	
	async updatePasswordCurrentUser(data) {
		var result = await this.makePUTRequest('/api/resource/users/currentuser/password', data);
		return result;
	}
	
	async getUsersForCompany(companyId, paging) {
		
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		
		if (companyId) {
			var users = await this.makeGETRequest('/api/resource/users/companies/' + companyId + params);			
		} else {
			var users = await this.makeGETRequest('/api/resource/users/companies/current' + params);
		}
		return users;
	}
	
	async deleteUser(userId) {
		var results = await this.makeDELETERequest('/api/resource/users/' + userId);
		return results;
	}
	
	async resetPassword(userId) {
		var result = await this.makePUTRequest('/api/resource/users/' + userId + '/resetpassword');
		return result;
	}	
	
	async activateUser(userId) {
		var result = await this.makePUTRequest('/api/resource/users/' + userId + '/activate');
		return result;
	}	
	
	async inactivateUser(userId) {
		var result = await this.makePUTRequest('/api/resource/users/' + userId + '/inactivate');
		return result;
	}
	
	async lockUser(userId) {
		var result = await this.makePUTRequest('/api/resource/users/' + userId + '/lock');
		return result;
	}	
	
	async unlockUser(userId) {
		var result = await this.makePUTRequest('/api/resource/users/' + userId + '/unlock');
		return result;
	}	

	async addNewUser(newUserModel) {
		var result = await this.makePOSTRequest('/api/resource/users', newUserModel);
		return result;
	}	

};
